import { useI18n } from '@change-corgi/core/react/i18n';

import { useLocalPageData } from 'src/app/pages/local/pageContext';
import { getUsState } from 'src/app/shared/utils/unitedStatesMapping';

type Result = ModelHookResult<{
	canonicalUrl: string;
	description: string;
	title: string;
}>;

export function usePageMeta(): Result {
	const {
		data: { displayName, slug, countryCode, stateCode },
	} = useLocalPageData();
	const { getCountry } = useI18n();
	const country = getCountry(countryCode)?.name;
	const state = getUsState(stateCode);
	const location = `${displayName}, ${state || country}`;

	return {
		data: {
			canonicalUrl: `https://www.change.org/local/${slug}`,
			description: `Discover and support local petitions in ${displayName} on Change.org. Join your community in making a difference by signing petitions that matter to you. Be a part of the change today!`,
			title: [`Petitions in ${displayName} - Support Local Causes & Make a Difference`, location].join(' | '),
		},
	};
}
